import {Component, inject, input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {OrgSwitcherComponent} from '../elements/components/org-switcher/org-switcher.component';
import {LogoComponent} from '../elements/components/app-logo/component';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {AssetMapKey, iconMap} from '../icons';
import {SideNavSection} from '../../model/menu.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './template.html',
  styleUrl: './style.scss',
  imports: [
    RouterLink,
    RouterLinkActive,
    OrgSwitcherComponent,
    LogoComponent
  ],
  host: {
    class: 'side-nav h-full'
  }
})
export class SidenavComponent {
  sections = input<SideNavSection[]>([]);

  private readonly authService = inject(AuthService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly isLoggedIn = this.authService.authenticated;


  // This provides the logout SVG as a data URI that can be used directly in an img src attribute
  readonly logoutSvgDataUri = iconMap.logoutSvg;

  getIconTemplate(icon: AssetMapKey = 'default'): SafeHtml {
    const svgTemplate = iconMap[icon];
    return this.sanitizer.bypassSecurityTrustHtml(svgTemplate);
  }

  async logout() {
    await this.authService.logout();
  }
}
